import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "800",
  height: "800",
  viewBox: "0 0 32 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M8.295 17.292a5.87 5.87 0 0 0-2.943 1.094l.017-.012c-2.306 2.004-.926 5.67 3.74 5.67a10.08 10.08 0 0 0 7.527-4.46l.023-.037c-2.313-1.417-5.114-2.256-8.111-2.256l-.268.002h.013zm12.799.872a23.6 23.6 0 0 0 2.468-6.139l.035-.166h-5.912V9.736h7.242V8.551h-7.242v-3.54h-2.972a.5.5 0 0 0-.502.502v3.039H6.887v1.185h7.324v2.123H8.164v1.185h11.729a20.7 20.7 0 0 1-1.744 4.224l.054-.107c-3.805-1.252-7.867-2.267-10.418-1.642a6.03 6.03 0 0 0-3.296 1.861l-.004.005c-2.833 3.438-.801 8.659 5.182 8.659a12.7 12.7 0 0 0 9.564-5.173l.025-.035c3.94 1.889 11.74 5.132 11.74 5.132v.196a4.795 4.795 0 0 1-4.795 4.79h-20.4a4.797 4.797 0 0 1-4.797-4.791V5.84A4.796 4.796 0 0 1 5.8 1.049h20.4a4.795 4.795 0 0 1 4.795 4.791v15.507a32 32 0 0 1-5.516-1.595l.218.075c-1.2-.401-2.81-1.014-4.604-1.661z" }, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }